import {connect} from 'react-redux';
import React, {Component} from 'react';

import Sidebar from "./Sidebar";
import MainContainer from "./MainContainer";

class MainRental extends Component {
    render() {
        let isShowBackgroundLoading = this.props.objectPage.isShowBackgroundLoading;

        return (
            <main className="clearfix">
                {isShowBackgroundLoading && <div className="loading"/>}
                <MainContainer/>
                <Sidebar/>
            </main>
        )
    }
}

const mapStateToProps = state => ({
    objectPage: state.objectPage
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MainRental);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Rental/MainRental.js